"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Providers;
(function (Providers) {
    Providers["Azure"] = "Azure";
    Providers["AWS"] = "AWS";
    Providers["AWSGovCloud"] = "AWSGovCloud";
    Providers["Cloudian"] = "Cloudian";
    Providers["Wasabi"] = "Wasabi";
    Providers["Alibaba"] = "Alibaba";
    Providers["DigitalOcean"] = "DigitalOcean";
    Providers["Exoscale"] = "Exoscale";
    Providers["Other"] = "Other";
    Providers["Zadara"] = "Zadara";
    Providers["GCP"] = "GCP";
    Providers["Telefonica"] = "Telefonica";
    Providers["Scality"] = "Scality";
    Providers["Nutanix"] = "Nutanix";
    Providers["Pure"] = "Pure";
    Providers["Dell"] = "Dell";
    Providers["IBM"] = "IBM";
    Providers["Backblaze"] = "Backblaze";
})(Providers = exports.Providers || (exports.Providers = {}));
var RegionContinent;
(function (RegionContinent) {
    RegionContinent["Europe"] = "Europe";
    RegionContinent["Asia"] = "Asia";
    RegionContinent["AsiaPacific"] = "Asia Pacific";
    RegionContinent["SouthAmerica"] = "South America";
    RegionContinent["NorthAmerica"] = "North America";
    RegionContinent["Africa"] = "Africa";
    RegionContinent["Australia"] = "Australia";
    RegionContinent["MiddleEast"] = "Middle East";
})(RegionContinent = exports.RegionContinent || (exports.RegionContinent = {}));
var RegionCountry;
(function (RegionCountry) {
    RegionCountry["Usa"] = "Usa";
    RegionCountry["Canada"] = "Canada";
})(RegionCountry = exports.RegionCountry || (exports.RegionCountry = {}));
var RegionsNorthAmericaLocation;
(function (RegionsNorthAmericaLocation) {
})(RegionsNorthAmericaLocation = exports.RegionsNorthAmericaLocation || (exports.RegionsNorthAmericaLocation = {}));
var RegionFlag;
(function (RegionFlag) {
    RegionFlag[RegionFlag["IbmSingleDataCenter"] = 0] = "IbmSingleDataCenter";
    RegionFlag[RegionFlag["ComingSoon"] = 1] = "ComingSoon";
})(RegionFlag = exports.RegionFlag || (exports.RegionFlag = {}));
exports.cloudProviders = {};
exports.cloudProviders[Providers.Azure] = {
    objectStore: 'azure',
    certified: true,
    locationConstraint: false,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    key: Providers.Azure,
    primaryName: 'Azure',
    secondaryName: 'Blob Storage',
    regionsList: [
        {
            continent: RegionContinent.Africa,
            name: 'South Africa North',
            region: 'South Africa North',
            endpoint: 'core.windows.net',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'East Asia',
            region: 'East Asia',
            endpoint: 'core.windows.net',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Southeast Asia',
            region: 'Southeast Asia',
            endpoint: 'core.windows.net',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Australia Central',
            region: 'Australia Central',
            endpoint: 'core.windows.net',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Australia East',
            region: 'Australia East',
            endpoint: 'core.windows.net',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Australia Southeast',
            region: 'Australia Southeast',
            endpoint: 'core.windows.net',
        },
        {
            continent: RegionContinent.SouthAmerica,
            name: 'Brazil South',
            region: 'Brazil South',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Canada,
            name: 'Canada Central',
            region: 'Canada Central',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Canada,
            name: 'Canada East',
            region: 'Canada East',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.Europe,
            name: 'North Europe',
            region: 'North Europe',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.Europe,
            name: 'West Europe',
            region: 'West Europe',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.Europe,
            name: 'France Central',
            region: 'France Central',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Central India',
            region: 'Central India',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'South India',
            region: 'South India',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'West India',
            region: 'West India',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Japan East',
            region: 'Japan East',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Japan West',
            region: 'Japan West',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Korea Central',
            region: 'Korea Central',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Korea South',
            region: 'Korea South',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.MiddleEast,
            name: 'UAE North',
            region: 'UAE North',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.Europe,
            name: 'UK South',
            region: 'UK South',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.Europe,
            name: 'UK West',
            region: 'UK West',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Central US',
            region: 'Central US',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'East US',
            region: 'East US',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'East US 2',
            region: 'East US 2',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'North Central US',
            region: 'North Central US',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'South Central US',
            region: 'South Central US',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'West Central US',
            region: 'West Central US',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'West US',
            region: 'West US',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'West US 2',
            region: 'West US 2',
            endpoint: 'core.windows.net'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'West US 3',
            region: 'West US 3',
            endpoint: 'core.windows.net'
        }
    ],
    regionMap: {
        aws: {
            'South Africa North': 'ap-south-1',
            'East Asia': 'ap-northeast-1',
            'Southeast Asia': 'ap-southeast-1',
            'Australia Central': 'ap-southeast-2',
            'Australia East': 'ap-southeast-2',
            'Australia Southeast': 'ap-southeast-4',
            'Brazil South': 'sa-east-1',
            'Canada Central': 'ca-central-1',
            'Canada East': 'ca-central-1',
            'North Europe': 'eu-north-1',
            'West Europe': 'eu-west-2',
            'France Central': 'eu-west-3',
            'Central India': 'ap-south-1',
            'South India': 'ap-south-1',
            'West India': 'ap-south-1',
            'Japan East': 'ap-northeast-1',
            'Japan West': 'ap-northeast-1',
            'Korea Central': 'ap-northeast-2',
            'Korea South': 'ap-northeast-2',
            'UAE North': 'ap-south-1',
            'UK South': 'eu-west-2',
            'UK West': 'eu-west-2',
            'Central US': 'us-east-2',
            'East US': 'us-east-2',
            'East US 2': 'us-east-2',
            'North Central US': 'us-east-2',
            'South Central US': 'us-east-2',
            'West Central US': 'us-west-1',
            'West US': 'us-west-1',
            'West US 2': 'us-west-1',
            'West US 3': 'us-west-1'
        },
        do: {
            'South Africa North': 'blr1',
            'East Asia': 'blr1',
            'Southeast Asia': 'blr1',
            'Australia Central': 'syd1',
            'Australia East': 'syd1',
            'Australia Southeast': 'syd1',
            'Brazil South': 'nyc3',
            'Canada Central': 'tor1',
            'Canada East': 'tor1',
            'North Europe': 'ams3',
            'West Europe': 'ams3',
            'France Central': 'fra1',
            'Central India': 'blr1',
            'South India': 'blr1',
            'West India': 'blr1',
            'Japan East': 'sgp1',
            'Japan West': 'sgp1',
            'Korea Central': 'sgp1',
            'Korea South': 'sgp1',
            'UAE North': 'blr1',
            'UK South': 'lon1',
            'UK West': 'lon1',
            'Central US': 'sfo3',
            'East US': 'nyc3',
            'East US 2': 'nyc3',
            'North Central US': 'nyc3',
            'South Central US': 'sfo3',
            'West Central US': 'sfo3',
            'West US': 'sfo3',
            'West US 2': 'sfo3',
            'West US 3': 'sfo3'
        }
    }
};
exports.cloudProviders[Providers.AWS] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: true,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    key: Providers.AWS,
    primaryName: 'Amazon',
    secondaryName: 'Web Services',
    regionsList: [
        {
            continent: RegionContinent.Africa,
            name: 'Cape Town, South Africa',
            region: 'af-south-1',
            endpoint: 'ec2.af-south-1.amazonaws.com',
            isLucidLinkProvided: false,
        },
        {
            continent: RegionContinent.Europe,
            name: 'Frankfurt, Germany',
            region: 'eu-central-1',
            endpoint: 'ec2.eu-central-1.amazonaws.com',
            isLucidLinkProvided: false,
        },
        {
            continent: RegionContinent.Europe,
            name: 'Ireland, Ireland',
            region: 'eu-west-1',
            endpoint: 'ec2.eu-west-1.amazonaws.com',
            isLucidLinkProvided: true,
        },
        {
            continent: RegionContinent.Europe,
            name: 'London, United Kingdom',
            region: 'eu-west-2',
            endpoint: 'ec2.eu-west-2.amazonaws.com',
            isLucidLinkProvided: true,
        },
        {
            continent: RegionContinent.Europe,
            name: 'Milan, Italy',
            region: 'eu-south-1',
            endpoint: 'ec2.eu-south-1.amazonaws.com',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Paris, France',
            region: 'eu-west-3',
            endpoint: 'ec2.eu-west-3.amazonaws.com',
            isLucidLinkProvided: false,
        },
        {
            continent: RegionContinent.Europe,
            name: 'Stockholm, Sweden',
            region: 'eu-north-1',
            endpoint: 'ec2.eu-north-1.amazonaws.com',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Tokyo, Japan',
            region: 'ap-northeast-1',
            endpoint: 'ec2.ap-northeast-1.amazonaws.com',
            isLucidLinkProvided: true,
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Seoul, South Korea',
            region: 'ap-northeast-2',
            endpoint: 'ec2.ap-northeast-2.amazonaws.com',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Mumbai, India',
            region: 'ap-south-1',
            endpoint: 'ec2.ap-south-1.amazonaws.com',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Singapore, Singapore',
            region: 'ap-southeast-1',
            endpoint: 'ec2.ap-southeast-1.amazonaws.com',
        },
        {
            continent: RegionContinent.Australia,
            name: 'Sydney, Australia',
            region: 'ap-southeast-2',
            endpoint: 'ec2.ap-southeast-2.amazonaws.com',
            isLucidLinkProvided: true,
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Ohio, United States',
            region: 'us-east-2',
            endpoint: 'ec2.us-east-2.amazonaws.com',
            isLucidLinkProvided: false,
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'North Virginia, United States',
            region: 'us-east-1',
            endpoint: 'ec2.us-east-1.amazonaws.com',
            isLucidLinkProvided: true,
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'North California, United States',
            region: 'us-west-1',
            endpoint: 'ec2.us-west-1.amazonaws.com',
            isLucidLinkProvided: false,
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Oregon, United States',
            region: 'us-west-2',
            endpoint: 'ec2.us-west-2.amazonaws.com',
            isLucidLinkProvided: true,
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Canada,
            name: 'Canada (Central), Canada',
            region: 'ca-central-1',
            endpoint: 'ec2.ca-central-1.amazonaws.com',
            isLucidLinkProvided: false,
        },
        {
            continent: RegionContinent.SouthAmerica,
            name: 'São Paulo, Brazil',
            region: 'sa-east-1',
            endpoint: 'ec2.sa-east-1.amazonaws.com',
        },
        {
            continent: RegionContinent.MiddleEast,
            name: 'Bahrain, Bahrain',
            region: 'me-south-1',
            endpoint: 'ec2.me-south-1.amazonaws.com',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Hong Kong, Hong Kong',
            region: 'ap-east-1',
            endpoint: 'ec2.ap-east-1.amazonaws.com',
        },
        {
            continent: RegionContinent.Australia,
            name: 'Melbourne, Australia',
            region: 'ap-southeast-4',
            endpoint: 'ec2.ap-southeast-4.amazonaws.com',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Hyderabad, India',
            region: 'ap-south-2',
            endpoint: 'ec2.ap-south-2.amazonaws.com',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Jakarta, Indonesia',
            region: 'ap-southeast-3',
            endpoint: 'ec2.ap-southeast-3.amazonaws.com',
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Malaysia, Malaysia',
            region: 'ap-southeast-5',
            endpoint: 'ec2.ap-southeast-5.amazonaws.com',
            isLucidLinkProvided: false,
        },
        {
            continent: RegionContinent.NorthAmerica,
            name: 'Calgary, Canada',
            region: 'ca-west-1',
            endpoint: 'ec2.ca-west-1.amazonaws.com',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Spain, Spain',
            region: 'eu-south-2',
            endpoint: 'ec2.eu-south-2.amazonaws.com',
            isLucidLinkProvided: false,
        },
        {
            continent: RegionContinent.Europe,
            name: 'Zurich, Switzerland',
            region: 'eu-central-2',
            endpoint: 'ec2.eu-central-2.amazonaws.com',
        },
        {
            continent: RegionContinent.MiddleEast,
            name: 'UAE, United Arab Emirates',
            region: 'me-central-1',
            endpoint: 'ec2.me-central-1.amazonaws.com',
        },
        {
            continent: RegionContinent.MiddleEast,
            name: 'Tel Aviv, Israel',
            region: 'il-central-1',
            endpoint: 'ec2.il-central-1.amazonaws.com',
        },
    ],
    regionMap: {
        aws: {
            'eu-central-1': 'eu-central-1',
            'eu-west-1': 'eu-west-1',
            'eu-west-2': 'eu-west-2',
            'eu-south-1': 'eu-south-1',
            'eu-west-3': 'eu-west-3',
            'eu-north-1': 'eu-north-1',
            'ap-northeast-1': 'ap-northeast-1',
            'ap-northeast-2': 'ap-northeast-2',
            'ap-south-1': 'ap-south-1',
            'ap-southeast-1': 'ap-southeast-1',
            'ap-southeast-2': 'ap-southeast-2',
            'us-east-1': 'us-east-1',
            'us-east-2': 'us-east-2',
            'us-west-1': 'us-west-1',
            'us-west-2': 'us-west-2',
            'ca-central-1': 'ca-central-1',
            'sa-east-1': 'sa-east-1',
            'af-south-1': 'af-south-1',
            'me-south-1': 'me-south-1',
            'ap-east-1': 'ap-east-1',
            'ap-southeast-4': 'ap-southeast-4',
            'ap-south-2': 'ap-south-2',
            'ap-southeast-3': 'ap-southeast-3',
            'ap-southeast-5': 'ap-southeast-5',
            'ca-west-1': 'ca-west-1',
            'eu-south-2': 'eu-south-2',
            'eu-central-2': 'eu-central-2',
            'me-central-1': 'me-central-1',
            'il-central-1': 'il-central-1'
        },
        do: {
            'eu-central-1': 'fra1',
            'eu-west-1': 'lon1',
            'eu-west-2': 'lon1',
            'eu-south-1': 'fra1',
            'eu-west-3': 'ams3',
            'eu-north-1': 'ams3',
            'ap-northeast-1': 'sgp1',
            'ap-northeast-2': 'sgp1',
            'ap-south-1': 'blr1',
            'ap-southeast-1': 'sgp1',
            'ap-southeast-2': 'syd1',
            'us-east-1': 'nyc3',
            'us-east-2': 'nyc3',
            'us-west-1': 'sfo3',
            'us-west-2': 'sfo3',
            'ca-central-1': 'tor1',
            'sa-east-1': 'nyc3',
            'af-south-1': 'lon1',
            'me-south-1': 'blr1',
            'ap-east-1': 'sgp1',
            'ap-southeast-4': 'syd1',
            'ap-south-2': 'blr1',
            'ap-southeast-3': 'sgp1',
            'ap-southeast-5': 'sgp1',
            'ca-west-1': 'tor1',
            'eu-south-2': 'fra1',
            'eu-central-2': 'fra1',
            'me-central-1': 'blr1',
            'il-central-1': 'fra1',
        }
    }
};
exports.cloudProviders[Providers.DigitalOcean] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: false,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    certifiedLabel: 'beta',
    key: Providers.DigitalOcean,
    primaryName: 'DigitalOcean',
    secondaryName: '',
    regionsList: [
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'New York City',
            region: 'nyc3',
            endpoint: 'nyc3.digitaloceanspaces.com',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Amsterdam',
            region: 'ams3',
            endpoint: 'ams3.digitaloceanspaces.com',
        },
        {
            continent: RegionContinent.Asia,
            name: 'Singapore',
            region: 'sgp1',
            endpoint: 'sgp1.digitaloceanspaces.com',
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'San Francisco',
            region: 'sfo2',
            endpoint: 'sfo2.digitaloceanspaces.com',
        },
        {
            continent: RegionContinent.Australia,
            name: "Sydney",
            region: 'syd1',
            endpoint: 'syd1.digitaloceanspaces.com'
        }
    ],
    regionMap: {
        aws: {
            'nyc3': 'us-east-1',
            'ams3': 'eu-central-1',
            'sgp1': 'ap-southeast-1',
            'sfo2': 'us-west-1',
            'syd1': 'ap-southeast-2'
        },
        do: {
            'nyc3': 'nyc3',
            'ams3': 'ams3',
            'sgp1': 'sgp1',
            'sfo2': 'sfo3',
            'syd1': 'syd1',
        }
    }
};
exports.cloudProviders[Providers.IBM] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: false,
    key: Providers.IBM,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    primaryName: 'IBM Cloud',
    secondaryName: 'Object Storage',
    regionsList: [
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Dallas, United States',
            region: 'us-south',
            endpoint: 's3.us-south.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Washington DC, United States',
            region: 'us-east',
            endpoint: 's3.us-east.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Canada,
            name: 'Toronto, Canada',
            region: 'ca-tor',
            endpoint: 's3.ca-tor.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.Europe,
            name: 'London, United Kingdom',
            region: 'eu-gb',
            endpoint: 's3.eu-gb.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.Europe,
            name: 'Frankfurt, Germany',
            region: 'eu-de',
            endpoint: 's3.eu-de.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.Australia,
            name: 'Sydney, Australia',
            region: 'au-syd',
            endpoint: 's3.au-syd.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Tokyo, Japan',
            region: 'jp-tok',
            endpoint: 's3.jp-tok.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Osaka, Japan',
            region: 'jp-osa',
            endpoint: 's3.jp-osa.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.SouthAmerica,
            name: 'São Paulo, Brazil',
            region: 'br-sao',
            endpoint: 's3.br-sao.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'San Jose, United States',
            region: 'sjc04',
            endpoint: 's3.sjc04.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true,
            flags: [RegionFlag.IbmSingleDataCenter]
        },
        {
            continent: RegionContinent.Europe,
            name: 'Amsterdam, Netherlands',
            region: 'ams03',
            endpoint: 's3.ams03.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true,
            flags: [RegionFlag.IbmSingleDataCenter]
        },
        {
            continent: RegionContinent.Europe,
            name: 'Paris, France',
            region: 'par01',
            endpoint: 's3.par01.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true,
            flags: [RegionFlag.IbmSingleDataCenter]
        },
        {
            continent: RegionContinent.Europe,
            name: 'Milan, Italy',
            region: 'mil01',
            endpoint: 's3.mil01.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true,
            flags: [RegionFlag.IbmSingleDataCenter]
        },
        {
            continent: RegionContinent.Europe,
            name: 'Madrid, Spain',
            region: 'eu-es',
            endpoint: 's3.eu-es.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Canada,
            name: 'Montrèal, Canada',
            region: 'mon01',
            endpoint: 's3.mon01.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true,
            flags: [RegionFlag.IbmSingleDataCenter]
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Chennai, India',
            region: 'che01',
            endpoint: 's3.che01.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true,
            flags: [RegionFlag.IbmSingleDataCenter]
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Singapore, Singapore',
            region: 'sng01',
            endpoint: 's3.sng01.cloud-object-storage.appdomain.cloud',
            isLucidLinkProvided: true,
            flags: [RegionFlag.IbmSingleDataCenter]
        }
    ],
    regionMap: {
        aws: {
            'us-south': 'us-east-2',
            'us-east': 'us-east-2',
            'ca-tor': 'ca-central-1',
            'eu-gb': 'eu-west-2',
            'eu-de': 'eu-central-1',
            'au-syd': 'ap-southeast-2',
            'jp-tok': 'ap-northeast-1',
            'jp-osa': 'ap-northeast-1',
            'sjc04': 'us-west-1',
            'ams03': 'eu-central-1',
            'par01': 'eu-west-3',
            'eu-es': 'eu-west-3',
            'mil01': 'eu-south-1',
            'mon01': 'ca-central-1',
            'che01': 'ap-south-1',
            'sng01': 'ap-southeast-1',
            'br-sao': 'us-west-1'
        },
        do: {
            'us-south': 'nyc3',
            'us-east': 'nyc3',
            'ca-tor': 'tor1',
            'eu-gb': 'lon1',
            'eu-de': 'fra1',
            'au-syd': 'syd1',
            'jp-tok': 'sgp1',
            'jp-osa': 'sgp1',
            'sjc04': 'sfo3',
            'ams03': 'ams3',
            'par01': 'lon1',
            'mil01': 'fra1',
            'eu-es': 'fra1',
            'mon01': 'tor1',
            'che01': 'blr1',
            'sng01': 'sgp1',
            'br-sao': 'nyc3'
        }
    }
};
exports.cloudProviders[Providers.AWSGovCloud] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: true,
    key: Providers.AWSGovCloud,
    primaryName: 'AWS',
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    secondaryName: 'Gov Cloud',
    regionsList: [
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'N. Virginia',
            region: 'us-gov-east-1',
            endpoint: 's3.us-gov-east-1.amazonaws.com'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'N. California',
            region: 'us-gov-west-1',
            endpoint: 's3.us-gov-west-1.amazonaws.com'
        }
    ],
    regionMap: {
        aws: {
            'us-gov-east-1': 'us-east-1',
            'us-gov-west-1': 'us-west-1'
        },
        do: {
            'us-gov-east-1': 'nyc3',
            'us-gov-west-1': 'sfo3'
        }
    }
};
exports.cloudProviders[Providers.Cloudian] = {
    objectStore: 's3',
    certified: true,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    locationConstraint: false,
    key: Providers.Cloudian,
    primaryName: 'Cloudian',
    secondaryName: 'Storage',
    regionRequired: true,
    endpointExample: 'https://myHyperStore:port',
    regionsList: [],
    regionMap: {
        aws: {},
        do: {}
    }
};
exports.cloudProviders[Providers.Wasabi] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: true,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    key: Providers.Wasabi,
    primaryName: 'Wasabi',
    secondaryName: 'Cloud',
    regionsList: [
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Ashburn, VA',
            region: 'us-east-1',
            endpoint: 's3.wasabisys.com',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Singapore',
            region: 'ap-southeast-1',
            endpoint: 's3.ap-southeast-1.wasabisys.com',
            isLucidLinkProvided: true,
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Sydney, Australia',
            region: 'ap-southeast-2',
            endpoint: 's3.ap-southeast-2.wasabisys.com',
            isLucidLinkProvided: true,
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Manassas, VA',
            region: 'us-east-2',
            endpoint: 's3.us-east-2.wasabisys.com',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Hillsboro, OR',
            region: 'us-west-1',
            endpoint: 's3.us-west-1.wasabisys.com',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Plano, TX',
            region: 'us-central-1',
            endpoint: 's3.us-central-1.wasabisys.com',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Canada,
            name: 'Toronto, Canada',
            region: 'ca-central-1',
            endpoint: 's3.ca-central-1.wasabisys.com',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.Europe,
            name: 'Amsterdam, NL',
            region: 'eu-central-1',
            endpoint: 's3.eu-central-1.wasabisys.com',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.Europe,
            name: 'London, UK',
            region: 'eu-west-1',
            endpoint: 's3.eu-west-1.wasabisys.com',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.Europe,
            name: 'Paris, France',
            region: 'eu-west-2',
            endpoint: 's3.eu-west-2.wasabisys.com',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.Europe,
            name: 'Frankfurt, Germany',
            region: 'eu-central-2',
            endpoint: 's3.eu-central-2.wasabisys.com',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Tokyo, Japan',
            region: 'ap-northeast-1',
            endpoint: 's3.ap-northeast-1.wasabisys.com',
            isLucidLinkProvided: true
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Osaka, Japan',
            region: 'ap-northeast-2',
            endpoint: 's3.ap-northeast-2.wasabisys.com',
            isLucidLinkProvided: true
        }
    ],
    regionMap: {
        aws: {
            'us-east-1': 'us-east-1',
            'us-west-1': 'us-west-1',
            'ca-central-1': 'ca-central-1',
            'eu-central-1': 'eu-central-1',
            'eu-central-2': 'eu-central-1',
            'eu-west-1': 'eu-west-2',
            'eu-west-2': 'eu-west-3',
            'us-east-2': 'us-east-1',
            'us-central-1': 'us-east-1',
            'ap-northeast-1': 'ap-northeast-1',
            'ap-northeast-2': 'ap-northeast-3',
            'ap-southeast-1': 'ap-southeast-1',
            'ap-southeast-2': 'ap-southeast-2'
        },
        do: {
            'us-east-1': 'nyc3',
            'us-west-1': 'sfo3',
            'ca-central-1': 'tor1',
            'eu-central-1': 'ams3',
            'eu-central-2': 'fra1',
            'eu-west-1': 'lon1',
            'eu-west-2': 'lon1',
            'us-east-2': 'nyc3',
            'us-central-1': 'nyc3',
            'ap-northeast-1': 'sgp1',
            'ap-northeast-2': 'sgp1',
            'ap-southeast-1': 'sgp1',
            'ap-southeast-2': 'syd1'
        }
    }
};
exports.cloudProviders[Providers.Backblaze] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: false,
    maxBucketNameLength: 50,
    defaultBlockSize: 1024 * 1024,
    key: Providers.Backblaze,
    primaryName: 'Backblaze',
    secondaryName: 'B2 Cloud Storage',
    regionsList: [
        {
            continent: RegionContinent.Europe,
            name: 'EU-Central-003',
            region: 'eu-central-003',
            endpoint: 's3.eu-central-003.backblazeb2.com',
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'US-West-000',
            region: 'us-west-000',
            endpoint: 's3.us-west-000.backblazeb2.com'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'US-West-001',
            region: 'us-west-001',
            endpoint: 's3.us-west-001.backblazeb2.com'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'US-West-002',
            region: 'us-west-002',
            endpoint: 's3.us-west-002.backblazeb2.com'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'US-West-004',
            region: 'us-west-004',
            endpoint: 's3.us-west-004.backblazeb2.com'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'US-East-005',
            region: 'us-east-005',
            endpoint: 's3.us-east-005.backblazeb2.com'
        }
    ],
    regionMap: {
        aws: {
            'eu-central-003': 'eu-central-1',
            'us-west-004': 'us-west-1',
            'us-west-000': 'us-west-1',
            'us-west-001': 'us-west-1',
            'us-west-002': 'us-west-1',
            'us-east-005': 'us-east-1'
        },
        do: {
            'eu-central-003': 'ams3',
            'us-west-004': 'sfo3',
            'us-west-000': 'sfo3',
            'us-west-001': 'sfo3',
            'us-west-002': 'sfo3',
            'us-east-005': 'nyc3'
        }
    }
};
exports.cloudProviders[Providers.Alibaba] = {
    objectStore: 's3',
    certified: true,
    certifiedLabel: 'beta',
    locationConstraint: false,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    key: Providers.Alibaba,
    primaryName: 'Alibaba',
    secondaryName: 'Cloud',
    useVirtualAddressing: true,
    regionsList: [
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Hong Kong',
            region: 'oss-cn-hongkong',
            endpoint: 'oss-cn-hongkong.aliyuncs.com'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Silicon Valley',
            region: 'oss-us-west-1',
            endpoint: 'oss-us-west-1.aliyuncs.com'
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Virginia',
            region: 'oss-us-east-1',
            endpoint: 'oss-us-east-1.aliyuncs.com'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Singapore',
            region: 'oss-ap-southeast-1',
            endpoint: 'oss-ap-southeast-1.aliyuncs.com'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Sydney',
            region: 'oss-ap-southeast-2',
            endpoint: 'oss-ap-southeast-2.aliyuncs.com'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Kuala Lumpur',
            region: 'oss-ap-southeast-3',
            endpoint: 'oss-ap-southeast-3.aliyuncs.com'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Jakarta',
            region: 'oss-ap-southeast-5',
            endpoint: 'oss-ap-southeast-5.aliyuncs.com'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Tokyo',
            region: 'oss-ap-northeast-1',
            endpoint: 'oss-ap-northeast-1.aliyuncs.com'
        },
        {
            continent: RegionContinent.AsiaPacific,
            name: 'Mumbai',
            region: 'oss-ap-south-1',
            endpoint: 'oss-ap-south-1.aliyuncs.com'
        },
        {
            continent: RegionContinent.Europe,
            name: 'Frankfurt',
            region: 'oss-eu-central-1',
            endpoint: 'oss-eu-central-1.aliyuncs.com'
        },
        {
            continent: RegionContinent.Europe,
            name: 'London',
            region: 'oss-eu-west-1',
            endpoint: 'oss-eu-west-1.aliyuncs.com'
        },
        {
            continent: RegionContinent.MiddleEast,
            name: 'Dubai',
            region: 'oss-me-east-1',
            endpoint: 'oss-me-east-1.aliyuncs.com'
        }
    ],
    regionMap: {
        aws: {
            'oss-cn-hongkong': 'ap-east-1',
            'oss-us-west-1': 'us-west-1',
            'oss-us-east-1': 'us-east-1',
            'oss-ap-southeast-1': 'ap-southeast-1',
            'oss-ap-southeast-2': 'ap-southeast-2',
            'oss-ap-southeast-3': 'ap-southeast-1',
            'oss-ap-southeast-5': 'ap-southeast-1',
            'oss-ap-northeast-1': 'ap-northeast-1',
            'oss-ap-south-1': 'ap-south-1',
            'oss-eu-central-1': 'eu-central-1',
            'oss-eu-west-1': 'eu-west-1',
            'oss-me-east-1': 'me-south-1'
        },
        do: {
            'oss-cn-hongkong': 'sgp1',
            'oss-us-west-1': 'sfo3',
            'oss-us-east-1': 'nyc3',
            'oss-ap-southeast-1': 'sgp1',
            'oss-ap-southeast-2': 'syd1',
            'oss-ap-southeast-3': 'sgp1',
            'oss-ap-southeast-5': 'sgp1',
            'oss-ap-northeast-1': 'blr1',
            'oss-ap-south-1': 'sgp1',
            'oss-eu-central-1': 'fra1',
            'oss-eu-west-1': 'lon1',
            'oss-me-east-1': 'blr'
        }
    }
};
exports.cloudProviders[Providers.Other] = {
    objectStore: 's3',
    certified: true,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    locationConstraint: false,
    key: Providers.Other,
    primaryName: 'Other',
    secondaryName: 'Cloud',
    regionRequired: false,
    endpointExample: 'https://ip:port',
    regionsList: [],
    regionMap: {
        aws: {},
        do: {}
    }
};
exports.cloudProviders[Providers.Zadara] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: false,
    key: Providers.Zadara,
    primaryName: 'Zadara',
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    secondaryName: 'Storage',
    regionRequired: true,
    endpointExample: 'https://myZIOSVPSA:port',
    regionsList: [],
    regionMap: {
        aws: {},
        do: {}
    }
};
exports.cloudProviders[Providers.GCP] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: true,
    key: Providers.GCP,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    primaryName: 'Google',
    secondaryName: 'Cloud',
    regionsList: [
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Iowa',
            region: 'us-central1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'South Carolina',
            region: 'us-east1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Northern Virginia',
            region: 'us-east4',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Oregon',
            region: 'us-west1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Los Angeles',
            region: 'us-west2',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.NorthAmerica,
            country: RegionCountry.Usa,
            name: 'Montréal',
            region: 'northamerica-northeast1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Finland',
            region: 'europe-north1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Belgium',
            region: 'europe-west1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Europe,
            name: 'London',
            region: 'europe-west2',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Frankfurt',
            region: 'europe-west3',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Netherlands',
            region: 'europe-west4',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.SouthAmerica,
            name: 'São Paulo',
            region: 'southamerica-east1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Asia,
            name: 'Taiwan',
            region: 'asia-east1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Asia,
            name: 'Hong Kong',
            region: 'asia-east2',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Asia,
            name: 'Tokyo',
            region: 'asia-northeast1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Asia,
            name: 'Mumbai',
            region: 'asia-south1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Asia,
            name: 'Singapore',
            region: 'asia-southeast1',
            endpoint: 'storage.googleapis.com',
        },
        {
            continent: RegionContinent.Australia,
            name: 'Sydney',
            region: 'australia-southeast1',
            endpoint: 'storage.googleapis.com',
        },
    ],
    regionMap: {
        aws: {
            'northamerica-northeast1': 'ca-central-1',
            'us-central1': 'us-east-2',
            'us-east1': 'us-east-1',
            'us-east4': 'us-east-1',
            'us-west1': 'us-west-2',
            'us-west2': 'us-west-1',
            'southamerica-east1': 'sa-east-1',
            'europe-north1': 'eu-central-1',
            'europe-west1': 'eu-central-1',
            'europe-west2': 'eu-west-2',
            'europe-west3': 'eu-central-1',
            'europe-west4': 'eu-central-1',
            'asia-east1': 'ap-northeast-1',
            'asia-east2': 'ap-northeast-1',
            'asia-northeast1': 'ap-northeast-1',
            'asia-south1': 'ap-south-1',
            'asia-southeast1': 'ap-southeast-1',
            'australia-southeast1': 'ap-southeast-2'
        },
        do: {
            'northamerica-northeast1': 'tor1',
            'us-central1': 'nyc3',
            'us-east1': 'nyc3',
            'us-east4': 'nyc3',
            'us-west1': 'sfo3',
            'us-west2': 'sfo3',
            'southamerica-east1': 'nyc3',
            'europe-north1': 'fra1',
            'europe-west1': 'fra1',
            'europe-west2': 'lon1',
            'europe-west3': 'fra1',
            'europe-west4': 'fra1',
            'asia-east1': 'blr1',
            'asia-east2': 'blr1',
            'asia-northeast1': 'blr1',
            'asia-south1': 'sgp1',
            'asia-southeast1': 'sgp1',
            'australia-southeast1': 'syd1'
        }
    }
};
exports.cloudProviders[Providers.Telefonica] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: true,
    key: Providers.Telefonica,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    primaryName: 'Telefonica',
    secondaryName: 'Open Cloud',
    regionsList: [{
            continent: RegionContinent.SouthAmerica,
            name: 'Argentina',
            region: 'sa-argentina-1',
            endpoint: 'obs.sa-argentina-1.telefonicaopencloud.com',
        }],
    regionMap: {
        aws: {
            'sa-argentina-1': 'sa-east-1'
        },
        do: {
            'sa-argentina-1': 'nyc3'
        }
    }
};
exports.cloudProviders[Providers.Scality] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: false,
    key: Providers.Scality,
    primaryName: 'Scality',
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    secondaryName: 'RING',
    regionRequired: true,
    endpointExample: 'https://ip:port',
    regionsList: [],
    regionMap: {
        aws: {},
        do: {}
    }
};
exports.cloudProviders[Providers.Exoscale] = {
    objectStore: 's3',
    certified: true,
    certifiedLabel: 'beta',
    locationConstraint: true,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    key: Providers.Exoscale,
    primaryName: 'Exoscale',
    secondaryName: 'Cloud Hosting',
    regionsList: [
        {
            continent: RegionContinent.Europe,
            name: 'Frankfurt',
            region: 'de-fra-1',
            endpoint: 'https://sos-de-fra-1.exo.io',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Vienna',
            region: 'at-vie-1',
            endpoint: 'https://sos-at-vie-1.exo.io',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Zurich',
            region: 'ch-dk-2',
            endpoint: 'https://sos-ch-dk-2.exo.io',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Geneva',
            region: 'ch-gva-2',
            endpoint: 'https://sos-ch-gva-2.exo.io',
        },
        {
            continent: RegionContinent.Europe,
            name: 'Sofia',
            region: 'bg-sof-1',
            endpoint: 'https://sos-bg-sof-1.exo.io',
        }
    ],
    regionMap: {
        aws: {
            'de-fra-1': 'eu-central-1',
            'at-vie-1': 'eu-central-1',
            'ch-dk-2': 'eu-central-1',
            'ch-gva-2': 'eu-west-3',
            'bg-sof-1': 'eu-central-1',
        },
        do: {
            'de-fra-1': 'fra1',
            'at-vie-1': 'fra1',
            'ch-dk-2': 'fra1',
            'ch-gva-2': 'fra1',
            'bg-sof-1': 'fra1',
        }
    }
};
exports.cloudProviders[Providers.Nutanix] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: false,
    key: Providers.Nutanix,
    primaryName: 'Nutanix',
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    secondaryName: 'Objects',
    regionRequired: true,
    endpointExample: 'https://ip:port',
    regionsList: [],
    regionMap: {
        aws: {},
        do: {}
    }
};
exports.cloudProviders[Providers.Pure] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: false,
    certifiedLabel: 'beta',
    key: Providers.Pure,
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    primaryName: 'Pure',
    secondaryName: 'Storage',
    regionRequired: true,
    endpointExample: 'https://ip:port',
    regionsList: [],
    regionMap: {
        aws: {},
        do: {}
    }
};
exports.cloudProviders[Providers.Dell] = {
    objectStore: 's3',
    certified: true,
    locationConstraint: false,
    key: Providers.Dell,
    primaryName: 'Dell EMC',
    maxBucketNameLength: 63,
    defaultBlockSize: 256 * 1024,
    secondaryName: 'ECS',
    regionRequired: true,
    endpointExample: 'https://ip:port',
    regionsList: [],
    regionMap: {
        aws: {},
        do: {}
    }
};
//# sourceMappingURL=CloudProviders.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/portal-shared-lib/build/CloudProviders.js
// module id = 566
// module chunks = 1